import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, addDoc, deleteDoc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

Vue.use(VueAxios, Axios);

const db = getFirestore();

Vue.use(VueAxios, Axios);

const storage = getStorage()
const storageImages = ref(storage, "articlesImages/");

export default {
    state:{
        articlesList: [],
        loadingStatusArticleImage:0,
        categoriesArticlesList:[]
    },
    mutations:{
        SET_ARTICLES_LIST(state, articlesList){
            state.articlesList = articlesList
        },
        SET_CATEGORIES_ARTICLES_LIST(state, categoriesArticlesList){
            state.categoriesArticlesList = categoriesArticlesList
        },
        SET_VALUE_LOADING_STATUS_ARTICLE_IMAGE(state, progress) {
            state.loadingStatusArticleImage = progress
        },
    },
    actions:{
        UpdateCreatedAtArticles({ commit }) {
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "articlesList"))
                    const articlesList = []
                    for (let i = 0; i < querySnapshot.docs.length; i++) {
                        let article = querySnapshot.docs[i].data();
                        
                        await updateDoc(doc(db, "articlesList", article.id), {
                            createdAt: new Date(),
                            updatedAt: new Date(),
                        })
                        console.log('documents updated:', i+1)
                        articlesList.push(article);
                    }
                    console.log(articlesList)
                    resolve(articlesList)
                } catch(error) {
                    reject(error)
                }
            });
        },
        UploadImageArticle({ commit }, article) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storage, `articlesImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, article.image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        GetArticlesList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "articlesList"))
                    const articlesList = []
                    querySnapshot.forEach(async(docSnapshot) =>  {
                        let article = docSnapshot.data()
                        let category = await getDoc(article.category)
                        article.category = category.data()
                        articlesList.push(article)
                    })
                    commit('SET_ARTICLES_LIST', articlesList)
                    resolve(articlesList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetArticle({ }, article){
            return new Promise(async (resolve, reject) => {
                try {
                    let resArticle = await getDoc(doc(db, "articlesList", article.id))
                    let gettedArticle = resArticle.data()
                    let category = await getDoc(gettedArticle.category)
                    gettedArticle.category = category.data()
                    resolve(gettedArticle)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetCategoriesArticlesList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "categoriesArticlesList"))
                    const categoriesArticlesList = []
                    querySnapshot.forEach((docSnapshot) =>  {
                        categoriesArticlesList.push(docSnapshot.data())
                    })
                    console.log(categoriesArticlesList)
                    commit('SET_CATEGORIES_ARTICLES_LIST', categoriesArticlesList)
                    resolve(categoriesArticlesList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateArticle({}, article) {
            return new Promise(async(resolve, reject) => {
                try {
                    delete article.image.img
                    article.category = doc(db, "categoriesArticlesList", article.category.id);
                    const newDocRef = doc(collection(db, "articlesList"));
                    article.id = newDocRef.id;
                    article.createdAt = new Date()
                    article.updatedAt = new Date()
                    await setDoc(newDocRef, article)
                    resolve(newDocRef.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        CreateCategoryArticle({}, categoryArticle) {
            return new Promise(async(resolve, reject) => {
                try {
                    const newDocRef = doc(collection(db, "categoriesArticlesList"));
                    categoryArticle.id = newDocRef.id;
                    await setDoc(newDocRef, categoryArticle)
                    resolve(newDocRef.id);
                } catch (error) {
                    reject(err);
                }
            })
        },
        UpdateArticle({}, article) {
            return new Promise(async(resolve, reject) => {
                try {
                    if (article.image.img) {
                        delete article.image.img
                    }
                    article.category = doc(db, "categoriesArticlesList", article.category.id);
                    if(article.createdAt) {
                        delete article.createdAt
                    }
                    article.updatedAt = new Date()
                    await updateDoc(doc(db, "articlesList", article.id), article)
                    resolve(article.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        UpdateCategoryArticle({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "categoriesArticlesList", category.id), category)
                    resolve(category.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteArticle({}, article) {
            return new Promise(async(resolve, reject) => {
                try {
                    let storageRefImage = ref(storage, `articlesImages/${article.image.ref}`);
                    await deleteObject(storageRefImage)
                    await deleteDoc(doc(db, "articlesList", article.id))
                    resolve(article.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteCategoryArticle({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    await deleteDoc(doc(db, "categoriesArticlesList", category.id))
                    resolve(category.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    getters:{
        getArticlesList(state){
            return state.articlesList;
        },
        getLoadingStatusArticleImage(state){
            return state.loadingStatusArticleImage;
        },
        getCategoriesArticlesList(state){
            return state.categoriesArticlesList;
        },
    }
}